<template>
  <g>
    <path
      fill="none"
      d="M0 0h24v24H0z"
    />
    <path d="M6.966 0A6.98 6.98 0 0 0 0 6.966v10.068A6.98 6.98 0 0 0 6.966 24h10.068A6.98 6.98 0 0 0 24 17.034V6.966A6.98 6.98 0 0 0 17.034 0zm0 1.846h10.068a5.105 5.105 0 0 1 5.12 5.12v10.068a5.105 5.105 0 0 1-5.12 5.12H6.966a5.105 5.105 0 0 1-5.12-5.12V6.966a5.105 5.105 0 0 1 5.12-5.12zm11.957 1.846a1.385 1.385 0 1 0 1.385 1.385 1.385 1.385 0 0 0-1.385-1.385zM12 5.538A6.462 6.462 0 1 0 18.462 12 6.474 6.474 0 0 0 12 5.538zm0 1.846A4.615 4.615 0 1 1 7.385 12 4.6 4.6 0 0 1 12 7.385z" />
  </g>
</template>
